import { tap } from 'rxjs/operators';
import { Store } from './../../core/state/store';
import { ReportsState } from './reports-state';
import { Injectable } from '@angular/core';
import { ReportsService } from '../core/reports.service';
import { Observable } from 'rxjs';
import { VehicleReportsIds } from '../models/interfaces/vehicle-by-reports.model';

@Injectable({
  providedIn: 'root',
})
export class ReportsStore extends Store<ReportsState> {
  constructor(private reportsService: ReportsService) {
    super(new ReportsState());
  }

  storeVehiclesReportsIds(): Observable<VehicleReportsIds[]> {
    return this.reportsService.getVehiclesReportsIds().pipe(
      tap((res) => {
        this.setState({
          ...this.state,
          vehiclesReportsIds: res,
        });
      })
    );
  }

  storeReportConfig(config: any) {
    this.setState({
      ...this.state,
      config,
    });
  }

  storeGeneratedReport(report: any, name: string) {
    this.setState({
      ...this.state,
      generatedReport: { ...report, name },
    });
  }

  storeGeneratedReports(reports: any[], name: string) {
    reports = reports.map(report => {
      return { ...report, name }
    });
    
    this.setState({
      ...this.state,
      generatedReport: reports
    });
  }

  clearGeneratedReport() {
    this.setState({
      ...this.state,
      generatedReport: undefined,
    });
  }

  storeLoadingReportStatus(loadingReport: boolean) {
    this.setState({
      ...this.state,
      loadingReport,
    });
  }
}
